export default __webpack_public_path__ + "static/media/hard_rock.2ad23be7.png";